<template>
  <!-- NOT MOBILE -->
    <v-btn-toggle
      v-if="!is_mobile && !disable_views"
      active-class="qmkey-explorer-view-active"
      background-color="white"
      borderless
      mandatory
      dense
      tile
      :value="view_pos(current_view)"
    >
      <v-btn
        v-for="view in views"
        :key="view.value"
        @click="change_view(view.value);"
        active-class="qmkey-explorer-view-active"
        icon
        disable_views
      >
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon 
              v-bind="attrs"
              v-on="on"
              medium
            >{{ view.icon }}</v-icon>
          </template>
          <span>{{ view.text }}</span>
        </v-tooltip>
      </v-btn>
    </v-btn-toggle>

  <!-- MOBILE -->
  <v-menu offset-y v-else>
    <template v-slot:activator="{ on, attrs }">
      <v-icon
        v-if="views.length > 1"
        color="primary"
        dark
        v-bind="attrs"
        v-on="on"
        medium
      >
        mdi-dots-vertical
      </v-icon>
    </template>

    <div class="text-right explorer-header-tabs" v-if="!disable_views">
      <v-list>
        <!-- VIEWS -->
        <v-list-item-group mandatory :value="view_pos(current_view)">
          <v-subheader>Views</v-subheader>
          <v-list-item 
            v-for="view in views"
            :key="view.value"
            @click="change_view(view.value);"
          >
            <div>
              <v-btn
                active-class="qmkey-explorer-view-active"
                icon
                disable_views
              >
                <v-icon small>{{ view.icon }}</v-icon>
              </v-btn>
              <span>{{ view.text }}</span>
            </div>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </div>
  </v-menu>
</template>

<style lang="scss">
  @import '@/sass/explorer.scss';

  .explorer-header-cont {
    display: flex;
    align-items: center;
    gap: 1em;
    /* height: 30px; */
    padding-left: 1em;
    padding-right: 1em;
    padding-top: .5em;
    padding-bottom: .5em;
  }

  .explorer-header-tabs {
    display: flex;
    align-items: center;
  }
  .mobile div{
    font-size: x-small !important;
  }
  .mobile span{
    font-size: x-small !important;
  }
</style>


<script>
  export default {
    name: 'ViewSelector',

    props: {
      views: {default: () => ([])},
      disable_views: Boolean,
      view_name: String,
      is_mobile: Boolean,
    },

    data: () => ({
      current_view: '',
    }),

    computed: {
    },

    mounted() {
      this.start_views();
    },
    methods: {
      start_views() {
        if (this.views.length > 0) {
          if (this.view_name && this.views.findIndex(view => view.value === this.view_name)) {
            this.current_view = this.view_name;
          } else {
            this.current_view = this.views[0].value;
          }
          
          if (this.is_mobile && this.views.findIndex(view => view.value === 'ExplorerCard') >= 0) {
            this.current_view = 'ExplorerCard';
          }
        }
        
        if (!this.view_name != this.current_view) {
          this.change_view(this.current_view);
        }
      },
      view_pos(view) {
        return this.views.findIndex(vi => vi.value === view);
      },
      change_view(target) {
        this.current_view = target;
        this.$emit("change_view", target);
      },

    },

    watch: {
      view_name() {
        if (this.view_name) {
          this.current_view = this.view_name;
        }
      }
    },
  }
</script>